<template>
  <div class="register-step">
    <div class="step-header">
      <h2>渠道注册</h2>
      <p class="subtitle">请输入手机号获取验证码</p>
    </div>
    
    <div class="form-group">
      <label>
        <i class="el-icon-phone label-icon"></i>
        手机号
      </label>
      <div class="input-wrapper">
        <input 
          :value="phone" 
          @input="$emit('update:phone', $event.target.value)"
          type="tel" 
          placeholder="请输入手机号"
          maxlength="11"
          :class="{ 'has-value': phone }"
        />
        <i class="el-icon-check input-indicator" v-if="isPhoneValid"></i>
      </div>
    </div>
    
    <div class="form-group">
      <label>
        <i class="el-icon-lock label-icon"></i>
        验证码
      </label>
      <div class="code-input">
        <div class="input-wrapper">
          <input 
            :value="code" 
            @input="$emit('update:code', $event.target.value)"
            type="tel" 
            inputmode="numeric"
            pattern="[0-9]*"
            placeholder="请输入验证码"
            maxlength="6"
            :class="{ 'has-value': code }"
          />
        </div>
        <button 
          class="code-btn"
          :disabled="codeBtnDisabled || !isPhoneValid"
          @click="$emit('send-code')"
        >
          <span v-if="!codeBtnDisabled">获取验证码</span>
          <span v-else>{{ codeBtnText }}</span>
        </button>
      </div>
    </div>
    
    <div class="btn-area">
      <button 
        class="submit-btn"
        :disabled="!canSubmit"
        @click="$emit('next')"
      >
        <span>下一步</span>
        <span class="btn-arrow">→</span>
      </button>
    </div>
    
    <div class="agreement">
      <span class="checkbox-wrapper" @click="$emit('toggle-protocol')">
        <span class="custom-checkbox" :class="{ checked: agreeProtocol }">
          <span class="checkmark" v-if="agreeProtocol">✓</span>
        </span>
      </span>
      <label>我已阅读并同意<span class="link" @click.stop="$emit('show-agreement', 'user')">《用户协议》</span>和<span class="link" @click.stop="$emit('show-agreement', 'privacy')">《隐私政策》</span></label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneVerifyStep',
  props: {
    phone: { type: String, default: '' },
    code: { type: String, default: '' },
    agreeProtocol: { type: Boolean, default: false },
    codeBtnDisabled: { type: Boolean, default: false },
    codeBtnText: { type: String, default: '获取验证码' }
  },
  computed: {
    canSubmit() {
      const phoneReg = /^1[3-9]\d{9}$/
      return phoneReg.test(this.phone) && this.code.length >= 4 && this.agreeProtocol
    },
    isPhoneValid() {
      const phoneReg = /^1[3-9]\d{9}$/
      return phoneReg.test(this.phone)
    }
  }
}
</script>

<style scoped>
.register-step {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 28px 20px;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.5) inset;
  animation: slideUp 0.5s ease-out;
  position: relative;
  overflow: hidden;
}


@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.step-header {
  text-align: center;
  margin-bottom: 28px;
}

.step-header h2 {
  font-size: 24px;
  color: #1a1a2e;
  margin: 0 0 8px;
  font-weight: 700;
  letter-spacing: 1px;
}

.step-header .subtitle {
  font-size: 14px;
  color: #8e8e93;
  margin: 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #1a1a2e;
  margin-bottom: 10px;
  font-weight: 600;
}

.label-icon {
  font-size: 16px;
}

.input-wrapper {
  position: relative;
  flex: 1;
}

.form-group input {
  width: 100%;
  height: 52px;
  border: 2px solid #e8e8ed;
  border-radius: 14px;
  padding: 0 16px;
  font-size: 16px;
  box-sizing: border-box;
  -webkit-appearance: none;
  appearance: none;
  background: linear-gradient(135deg, #fafafa 0%, #fff 100%);
  touch-action: manipulation;
  outline: none;
  transition: all 0.3s ease;
}

.form-group input:focus {
  border-color: #2B77FF;
  box-shadow: 0 0 0 4px rgba(43, 119, 255, 0.1);
  background: #fff;
}

.form-group input.has-value {
  border-color: #2B77FF;
}

.input-indicator {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #7EBF50 0%, #6AAD40 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  animation: scaleIn 0.3s ease;
}

@keyframes scaleIn {
  from { transform: translateY(-50%) scale(0); }
  to { transform: translateY(-50%) scale(1); }
}

.code-input {
  display: flex;
  gap: 12px;
  min-width: 0;
}

.code-input .input-wrapper {
  flex: 1;
}

.code-input input {
  width: 100%;
}

.code-btn {
  min-width: 110px;
  height: 52px;
  background: linear-gradient(135deg, #2B77FF 0%, #1A5FD9 100%);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(43, 119, 255, 0.3);
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  transition: all 0.3s ease;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(43, 119, 255, 0.3);
}

.code-btn:active {
  transform: scale(0.96);
  box-shadow: 0 2px 8px rgba(43, 119, 255, 0.3);
}

.code-btn:disabled {
  background: linear-gradient(135deg, #c0c0c0 0%, #a0a0a0 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-area {
  display: flex;
  gap: 12px;
  margin-top: 28px;
}

.submit-btn {
  flex: 1;
  height: 54px;
  background: linear-gradient(135deg, #2B77FF 0%, #1A5FD9 100%);
  color: #fff;
  border: none;
  border-radius: 27px;
  font-size: 17px;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(43, 119, 255, 0.3);
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  transition: all 0.3s ease;
  font-weight: 600;
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 8px 25px rgba(43, 119, 255, 0.35);
  letter-spacing: 1px;
}

.submit-btn:active {
  transform: scale(0.97);
  box-shadow: 0 4px 15px rgba(43, 119, 255, 0.35);
}

.submit-btn:disabled {
  background: linear-gradient(135deg, #d0d0d0 0%, #b0b0b0 100%);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.btn-arrow {
  font-size: 18px;
  transition: transform 0.3s ease;
}

.submit-btn:not(:disabled):hover .btn-arrow {
  transform: translateX(4px);
}

.agreement {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 13px;
  color: #8e8e93;
  padding: 12px 0;
  -webkit-tap-highlight-color: transparent;
}

.agreement .checkbox-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
}

.custom-checkbox {
  width: 22px;
  height: 22px;
  border: 2px solid #d0d0d0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background: #fff;
}

.custom-checkbox.checked {
  background: linear-gradient(135deg, #2B77FF 0%, #1A5FD9 100%);
  border-color: #2B77FF;
}

.custom-checkbox .checkmark {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.agreement .link {
  color: #2B77FF;
  cursor: pointer;
  font-weight: 500;
}

@media screen and (max-width: 480px) {
  .register-step {
    padding: 20px 12px;
    border-radius: 12px;
  }

  .step-header h2 {
    font-size: 20px;
  }

  .step-header .subtitle {
    font-size: 13px;
  }

  .code-btn {
    width: 90px;
    font-size: 12px;
    padding: 0 8px;
  }
}

@media screen and (max-width: 360px) {
  .register-step {
    padding: 16px 10px;
  }

  .step-header h2 {
    font-size: 18px;
  }

  .code-btn {
    width: 80px;
    font-size: 11px;
  }
}
</style>
